import * as React from "react";
import TextField from "@mui/material/TextField";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import calendar from "react-date-object/calendars/jalali";
import persian from "react-date-object/calendars/persian";
import { useSelector } from "react-redux";
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

interface DatePickerCmpPropsInterface {
  onChange: Function;
  value?: Date | null;
  error?: boolean;
  helperText?: string;
  label?: string;
  range: boolean;
  valueArray?: Date[] | null;
  fixMainPosition?: boolean;
  disable?: boolean;
}
let mainColor: any;

export default function DatePickerComponents({
  onChange,
  value,
  error = false,
  helperText = "",
  label = "",
  range,
  valueArray,
  fixMainPosition,
  disable,
}: DatePickerCmpPropsInterface) {
  function handleOnChange(newValue: any) {
    onChange(newValue);
  }
  let dateYear = valueArray
    ? new Date(valueArray[0])
        .toLocaleDateString("fa-IR-u-ca-persian")
        .split("/")[0]
    : new Date(value ?? new Date())
        .toLocaleDateString("fa-IR-u-ca-persian")
        .split("/")[0];

  return (
    <>
      <DatePicker
        render={
          <CustomComponent label={label} error={error} disable={disable} />
        }
        disabled={disable}
        inputClass="form-control"
        value={valueArray != undefined ? valueArray : value || null}
        format={
          label == "*تاریخ و ساعت تحویل کالا"
            ? " HH:mm - YYYY/MM/DD"
            : "YYYY/MM/DD"
        }
        className="datePicker"
        calendar={dateYear === "۱۴۰۴" ? persian : calendar}
        onYearChange={(date: any) => {
          handleOnChange(date);
        }}
        onChange={(newValue: any) => {
          handleOnChange(newValue as Date);
        }}
        locale={persian_fa}
        calendarPosition="bottom-center"
        containerStyle={{ width: "100%" }}
        plugins={
          label == "*تاریخ و ساعت تحویل کالا"
            ? [<TimePicker position="bottom" />]
            : [<Toolbar position="bottom" />]
        }
        range={range}
        dateSeparator=" - "
        fixMainPosition={fixMainPosition}
      />
    </>
  );
}

const CustomComponent = (props: any) => {
  const jsonFile = useSelector((state: any) => state.style);
  mainColor = jsonFile?.mainColor;
  const CssTextField = styled(TextField)({
    opacity: props.disable ? ".6" : "",
    "& label.Mui-focused": {
      color: mainColor,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: mainColor,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: mainColor,
      },
    },
  });
  return (
    <CacheProvider value={cacheRtl}>
      <FormControl fullWidth>
        <CssTextField
          value={props.value}
          onClick={props.openCalendar}
          label={props.label}
          error={props.error}
          id="custom-css-outlined-input"
          autoComplete="off"
          onFocus={(e: any) => e.target.blur()}
        />
      </FormControl>
    </CacheProvider>
  );
};
